import { createGQLQuery } from 'graphql/helpers'
import { FeatureFlags } from 'interfaces/global'

const FEATURE_FLAGS_QUERY = `
{
  global {
    feature_flags
  }
}
` as const

type FeatureFlagsResponse = {
  global: {
    feature_flags: FeatureFlags
  }
}

export const gqlFeatureFlagsQuery = createGQLQuery<typeof FEATURE_FLAGS_QUERY, FeatureFlagsResponse>(FEATURE_FLAGS_QUERY)
